// extracted by mini-css-extract-plugin
export default {"icon":"joyLt","more":"u9Y+H","actions":"_6UGNk","small":"wKJ4q","extended":"ooIm0","fixedHeight":"_3CaAj","actionsTop":"R2avN _6UGNk","buttonBorder":"Qv2N6"};